import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as Icons from './icons';

export default function SidebarGroup({ group, collapsed, onMobileClose }) {
  const location = useLocation();
  const { t } = useTranslation();

  const activeRequestsCount = useSelector((state) => state.ACTIVE_REQUESTS_COUNT);
  const activeCredentialsCount = useSelector((state) => state.ACTIVE_CREDENTIALS_COUNT);
  const activePayoutsCount = useSelector((state) => state.ACTIVE_PAYOUTS_COUNT);
  const unreadNewsCount = useSelector((state) => state.UNREAD_NEWS_COUNT);
  const payoutSettingsEnabled = useSelector((state) => state.PAYOUT_SETTINGS_ENABLED);
  const hasPayoutSettings = useSelector((state) => state.HAS_PAYOUT_SETTINGS);
  const hasRegulation = useSelector((state) => state.HAS_REGULATION);
  const isSuperuser = useSelector((state) => state.IS_SUPERUSER);
  const userChat = useSelector((state) => state.USER_CHAT);
  const supportBotMode = useSelector((state) => state.SUPPORT_BOT_MODE);
  const supportBotConnected = useSelector((state) => state.SUPPORT_BOT_CONNECTED);
  const supportBotTopicActive = useSelector((state) => state.SUPPORT_BOT_TOPIC_ACTIVE);

  const badgeValues = {
    ACTIVE_REQUESTS_COUNT: activeRequestsCount,
    ACTIVE_CREDENTIALS_COUNT: activeCredentialsCount,
    ACTIVE_PAYOUTS_COUNT: activePayoutsCount,
    UNREAD_NEWS_COUNT: unreadNewsCount,
  };

  const needsSettingsWarning = !userChat ||
    (supportBotMode === 'with_token' && (!supportBotConnected || !supportBotTopicActive));

  const groupLabel = t(group.groupLabelKey);

  return (
    <div className="SidebarGroup">
      {!collapsed && <div className="SidebarGroup__label">{groupLabel}</div>}
      <div className="SidebarGroup__items">
        {group.items.map((item) => {
          // Conditional rendering based on conditionalKey
          const conditionalValues = {
            HAS_PAYOUT_SETTINGS: hasPayoutSettings,
            HAS_REGULATION: hasRegulation,
            IS_SUPERUSER: isSuperuser,
          };
          if (item.conditionalKey && !conditionalValues[item.conditionalKey]) return null;

          const IconComponent = Icons[item.icon];
          const isActive = location.pathname === item.path;
          const badgeValue = item.badgeKey ? badgeValues[item.badgeKey] : null;
          const showWarning = item.warningBadge && needsSettingsWarning;
          const itemLabel = t(item.labelKey);

          // Badge color for payouts
          let badgeClass = 'SidebarGroup__badge';
          if (item.badgeColorKey) {
            badgeClass += payoutSettingsEnabled ? ' badge--green' : ' badge--red';
          }

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`SidebarGroup__link ${isActive ? 'active' : ''}`}
              title={itemLabel}
              onClick={onMobileClose}
            >
              <span className="SidebarGroup__icon">
                {IconComponent && <IconComponent />}
              </span>
              {!collapsed && <span className="SidebarGroup__text">{itemLabel}</span>}
              {badgeValue > 0 && (
                <span className={badgeClass}>{badgeValue}</span>
              )}
              {showWarning && (
                <span className="SidebarGroup__badge badge--warning">!</span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
